module.exports = {"headline":"Dominic Tracey\n","subtitle":"test","body":"<p>I build nice things</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./intro.md
// module id = 783
// module chunks = 0